import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useCompanyContext } from "../../common/company/CompanyContext";
import { useNavigationContext } from "../../common/navigation/NavigationContext";
import CompanyIdentityHeader from "../../common/company/CompanyIdentityHeader";
// 🎯 Alias bypasses the underscore naming rules for react/jsx-pascal-case
import SupplierController from "./SupplierController";

/**
 * 🎯 SUPPLIER WORKSPACE
 * Direct landing page for "Suppliers" on the Company Dashboard — reuses the
 * existing SupplierController/SupplierView (single-hit Name+Address create,
 * same shape as Register Company/Manage Child Companies, plus ESG taxonomy
 * classification per supplier) without routing through CorporateDetailsView's
 * registry table + expand-row click path.
 */
export default function SupplierWorkspaceView() {
  const navigate = useNavigate();
  const { activeCompanyId, activeCompanyName } = useCompanyContext();
  const { setWorkflowContext } = useNavigationContext();

  useEffect(() => {
    setWorkflowContext("Suppliers", "/registered/suppliers");
  }, [setWorkflowContext]);

  useEffect(() => {
    if (!activeCompanyId) {
      navigate("/registered/dashboard");
    }
  }, [activeCompanyId, navigate]);

  if (!activeCompanyId) return null;

  return (
    <main id="main" className="page-main" data-scroll-container>
      <div className="page-main-inner">
        <section className="page-section">
          <div className="container mt-4">
            <div className="row mb-2">
              <div className="col">
                <h2 className="h4 fw-bold mb-1">Suppliers</h2>
                <p className="text-muted extra-small text-uppercase fw-bold mb-0">To whom they supply</p>
              </div>
            </div>

            <CompanyIdentityHeader companyId={activeCompanyId} siteKey={process.env.REACT_APP_SITE_KEY} />

            <SupplierController companyId={activeCompanyId} companyName={activeCompanyName} />

            {/* FOOTER NAVIGATION */}
            <div className="mt-5 pt-4 border-top d-flex justify-content-between align-items-center">
              <button
                className="btn btn-link text-decoration-none p-0 text-primary fw-bold small"
                onClick={() => navigate("/registered/company-dashboard")}
              >
                <i className="bi bi-arrow-left me-2"></i> Back
              </button>
              <div className="text-end">
                <span className="text-muted extra-small d-block">Workflow Context</span>
                <span className="fw-bold small">{activeCompanyName}</span>
              </div>
            </div>
          </div>
        </section>
      </div>
    </main>
  );
}
